export const getDayAndMonth = (str) => {
    let date = new Date(str).toLocaleDateString();
    let dateArr = date.split(".");
    return `${dateArr[0]}.${dateArr[1]}`;
};

export const getDateAndTime = (str) => {
    let dateAndTime = new Date(str).toLocaleString();
    let arr = dateAndTime.split(",");
    let timeArr = arr[1].split(":");
    return [arr[0], `${timeArr[0]}:${timeArr[1]}`];
};

export const getDayMounthYear = (str) => (str ? new Date(str).toLocaleString().split(",")[0] : "");

export const is24hoursTimeGap = (from, to) => {
  const fromHours = from.getHours();
  const fromMinutes = from.getMinutes();
  const fromSeconds = from.getSeconds();
  const toHours = to.getHours();
  const toMinutes = to.getMinutes();
  const toSeconds = to.getSeconds();

  return fromHours === 0 && fromMinutes === 0 && fromSeconds === 0 && toHours === 23 && toMinutes === 59 && toSeconds === 59;
};

/**
 * Format date as DD.MM.YYYY
 * @param {string|Date} date - Date string or Date object
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}.${month}.${year}`;
};

/**
 * Format date and time as DD.MM.YYYY, HH:MM
 * @param {string|Date} date - Date string or Date object
 * @returns {string} Formatted date and time string
 */
export const formatDateTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return `${day}.${month}.${year}, ${hours}:${minutes}`;
};